import React from 'react'
import PropTypes from 'prop-types'
import style from './style.scss'//NOSONAR
import { HtmlParse } from 'utils';

const EmotionalInformation = (props) => {
    const { product } = props;

    if (!(product && product['Información Emocional'])) {
        return ""
    }

    const information = product['Información Emocional'].map((item) => {

        if (!(product[item] && product[item][0])) {
            return false
        }
        return {
            title: item,
            data: product[item][0]
        }
    }).filter(Boolean)

    return (
        <div className="product-emotional-information">
            {information.map((item, i) => {
                return <span className="product-emotional-information-items" key={i}>
                    <div className="product-emotional-information-title">{item.title}</div>
                    <div className="product-emotional-information-text">{HtmlParse(item.data)}</div>
                </span>
            })}
        </div>
    )

}

EmotionalInformation.propTypes = {
    product: PropTypes.object,
}

export default EmotionalInformation;